import { GetInsoleModelRequest, InEvertion, MedialLongitudinalArchHigh, MedialLongitudinalArchPosition } from "../api/scanner/scanner_service";

export function formatInsoleModelDataToPx(insoleData) {
    let width = 160;

    /* 内足弓高度 */
    let medialLongitudinalArchHighPx = 6; // A_MINUS_100
    if (insoleData.medialLongitudinalArchHigh === "A0") {
        medialLongitudinalArchHighPx = width * 0.5;
    }
    else if (insoleData.medialLongitudinalArchHigh === "A_PLUS_100") {
        medialLongitudinalArchHighPx = width * 1;
    }

    /* 内足弓位置 */
    let medialLongitudinalArchPositionPx = 6; // B_PLUS_100
    if (insoleData.medialLongitudinalArchPosition === "B0") {
        medialLongitudinalArchPositionPx = width * 0.5;
    }
    else if (insoleData.medialLongitudinalArchPosition === "B_MINUS_100") {
        medialLongitudinalArchPositionPx = width * 1;
    }


    /* 内外翻 */
    let inEvertionPx = 6; // D_MINUS_100
    if (insoleData.inEvertion === "D_MINUS_50") {
        inEvertionPx = width * 0.3;
    }
    else if (insoleData.inEvertion === "D0") {
        inEvertionPx = width * 0.5;
    }
    else if (insoleData.inEvertion === "D_PLUS_50") {
        inEvertionPx = width * 0.7;
    }
    else if (insoleData.inEvertion === "D_PLUS_100") {
        inEvertionPx = width * 1;
    }
   
    return {
        medialLongitudinalArchHighPx,
        medialLongitudinalArchPositionPx,
        inEvertionPx,
    }

}


// 获取鞋垫模型 stl 请求
export function formatGetInsoleModelRequest(data) {

    let width = 160;

    /* 内足弓高度 */
    let medialLongitudinalArchHigh = MedialLongitudinalArchHigh.A_MINUS_100;
    if (data.medialLongitudinalArchHighPx >= width * 0.33 &&
        data.medialLongitudinalArchHighPx < width * 0.66) {
        medialLongitudinalArchHigh = MedialLongitudinalArchHigh.A0;
    }
    else if (data.medialLongitudinalArchHighPx >= width * 0.66) {
        medialLongitudinalArchHigh = MedialLongitudinalArchHigh.A_PLUS_100;
    }

    /* 内足弓位置 */
    let medialLongitudinalArchPosition = MedialLongitudinalArchPosition.B_PLUS_100;
    if (data.medialLongitudinalArchPositionPx >= width * 0.33 &&
        data.medialLongitudinalArchPositionPx < width * 0.66) {
        medialLongitudinalArchPosition = MedialLongitudinalArchPosition.B0;
    }
    else if (data.medialLongitudinalArchPositionPx >= width * 0.66) {
        medialLongitudinalArchPosition = MedialLongitudinalArchPosition.B_MINUS_100;
    }
   
    /* 内外翻 */
    let inEvertion = InEvertion.D_MINUS_100;
    if (data.inEvertionPx >= width * 0.2 &&
        data.inEvertionPx < width * 0.4) {
        inEvertion = InEvertion.D_MINUS_50;
    }
    else if (data.inEvertionPx >= width * 0.4 &&
        data.inEvertionPx <= width * 0.6) {
        inEvertion = InEvertion.D0;
    }
    else if (data.inEvertionPx >= width * 0.6 &&
        data.inEvertionPx < width * 0.8) {
        inEvertion = InEvertion.D_PLUS_50;
    }
    else if (data.inEvertionPx >= width * 0.8) {
        inEvertion = InEvertion.D_PLUS_100;
    }


    let sdata: GetInsoleModelRequest = {
        medialLongitudinalArchHigh,
        medialLongitudinalArchPosition,
        inEvertion,
        length: data.length == 220 ?  225 : data.length,
        footSide: data.footSide,
    }
    return sdata;

}

export function formatGetInsoleModelToString(data) {

    let width = 160;

    /* 内足弓高度 */
    let medialLongitudinalArchHigh = 'A_MINUS_100';
    if (data.medialLongitudinalArchHighPx >= width * 0.33 &&
        data.medialLongitudinalArchHighPx < width * 0.66) {
        medialLongitudinalArchHigh = 'A0';
    }
    else if (data.medialLongitudinalArchHighPx >= width * 0.66) {
        medialLongitudinalArchHigh = 'A_PLUS_100';
    }

    /* 内足弓位置 */
    let medialLongitudinalArchPosition = 'B_PLUS_100';
    if (data.medialLongitudinalArchPositionPx >= width * 0.33 &&
        data.medialLongitudinalArchPositionPx < width * 0.66) {
        medialLongitudinalArchPosition = 'B0';
    }
    else if (data.medialLongitudinalArchPositionPx >= width * 0.66) {
        medialLongitudinalArchPosition = 'B_MINUS_100';
    }
   
    /* 内外翻 */
    let inEvertion = 'D_MINUS_100';
    if (data.inEvertionPx >= width * 0.2 &&
        data.inEvertionPx < width * 0.4) {
        inEvertion = 'D_MINUS_50';
    }
    else if (data.inEvertionPx >= width * 0.4 &&
        data.inEvertionPx <= width * 0.6) {
        inEvertion = 'D0';
    }
    else if (data.inEvertionPx >= width * 0.6 &&
        data.inEvertionPx < width * 0.8) {
        inEvertion = 'D_PLUS_50';
    }
    else if (data.inEvertionPx >= width * 0.8) {
        inEvertion = 'D_PLUS_100';
    }


    let sdata = {
        medialLongitudinalArchHigh,
        medialLongitudinalArchPosition,
        inEvertion,
        length: data.length,
        footSide: data.footSide,
    }
    return sdata;

}